import { atom } from 'jotai';

interface DrawerState {
  display: boolean;
  view: string;
  data?: any;
}

export const searchDrawerAtom = atom<DrawerState>({
  display: false,
  view: '',
  data: null,
});
